var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root",class:{ overlay: _vm.overlay }},[_c('svg',{staticClass:"ntds-treecon spinner",class:( _obj = { center: _vm.center }, _obj[_vm.sizeClass] = true, _obj ),attrs:{"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"45"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }